import { jsx as _jsx } from "react/jsx-runtime";
import ItemsList from "template-store/components/items-list/items-list-component";
import { useMemo, useCallback } from "react";
import colors from "styles/colors";
const COLUMN_COLORS = {
    button: "#514FC8",
    subtasks: colors["light-blue"],
    dependency: colors["brand-iris"],
    dropdown: colors["platform-red"],
    integration: colors["brand-turqoise"],
    "multiple-person": colors["brand-turqoise"],
    email: colors["brand-yellow"],
    lookup: colors["platform-red"],
    "board-relation": colors["platform-red"],
    file: colors["brand-turqoise"],
    hour: colors["brand-yellow"],
    formula: colors["brand-iris"],
    text: colors["light-blue"],
    tag: colors.purple,
    person: colors["brand-green"],
    votes: colors["brand-green"],
    color: colors["light-blue"],
    rating: colors["light-blue"],
    numeric: colors["brand-yellow"],
    "color-picker": colors["light-blue"],
    timerange: colors.purple,
    date: colors["brand-green"],
    "pulse-log": colors["brand-iris"],
    "pulse-updated": colors["platform-red"],
    timezone: "#514FC8",
    country: colors.purple,
    location: colors["platform-red"],
    "pulse-id": colors["light-blue"],
    link: colors["light-blue"],
    "columns-battery": colors.purple,
    week: colors["brand-yellow"],
    action: colors["platform-red"],
    "app-feature": "#666",
    autonumber: colors["brand-yellow"],
    group: colors["brand-yellow"],
    boolean: colors["brand-yellow"],
    "custom-url": colors["brand-turqoise"],
    duration: colors["brand-iris"],
    "long-text": colors["brand-iris"],
    phone: colors["brand-iris"],
    team: colors["brand-turqoise"]
};
const ColumnsComponent = ({ templateData, metadata })=>{
    const { columns } = templateData;
    const getcolumnMetadata = useCallback((column)=>{
        return metadata === null || metadata === void 0 ? void 0 : metadata.find((columnMetadata)=>columnMetadata.type === column);
    }, [
        metadata
    ]);
    const columnsData = useMemo(()=>{
        if (!columns) return;
        return columns.map((column)=>{
            const columnMetadata = getcolumnMetadata(column);
            if (!columnMetadata) return null;
            return {
                title: columnMetadata.title,
                description: columnMetadata.description,
                icon: columnMetadata.icon,
                backgroundColor: COLUMN_COLORS[columnMetadata.type] || colors["brand-iris"]
            };
        });
    }, [
        getcolumnMetadata,
        columns
    ]);
    return columns ? /*#__PURE__*/ _jsx(ItemsList, {
        items: columnsData
    }) : null;
};
export default ColumnsComponent;
